import React, { useState } from "react";
import { Button } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import { createGRN } from "logic/permissions/GRN";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import useCollectionEntityMutation from "collections/hooks/useCollectionEntityMutation";
import { useTranslation } from "react-i18next";
const CollectionEntityActions = ({ id, name, collectionId, type }) => {
  const { t } = useTranslation("enterprise_collections");
  const { deselectEntity } = useSelectedEntities();
  const { removeEntities } = useCollectionEntityMutation(collectionId);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const cancelDelete = () => {
    setShowDeleteDialog(false);
    deselectEntity(id);
  };
  const handleDelete = () => {
    removeEntities({ removedEntities: [createGRN(type, id)] }).then(() => {
      deselectEntity(id);
      setShowDeleteDialog(false);
    });
  };
  const onDelete = () => {
    setShowDeleteDialog(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showDeleteDialog,
      title: t("entity_actions.remove_title"),
      onCancel: cancelDelete,
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, t("entity_actions.remove_confirm", { name }))
  ), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `collection_entities:edit:${collectionId}` }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "danger", onClick: onDelete }, t("entity_actions.remove"))));
};
export default CollectionEntityActions;
